import type { FC } from "react"

interface Props {
  className?: string
}

const QuestionMark: FC<Props> = ({ className }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M9.75 0C7.82164 0 5.93657 0.571828 4.33319 1.64317C2.72982 2.71451 1.48013 4.23726 0.742179 6.01884C0.00422452 7.80042 -0.188858 9.76082 0.187348 11.6521C0.563554 13.5434 1.49215 15.2807 2.85571 16.6443C4.21928 18.0079 5.95656 18.9365 7.84787 19.3127C9.73919 19.6889 11.6996 19.4958 13.4812 18.7578C15.2627 18.0199 16.7855 16.7702 17.8568 15.1668C18.9282 13.5634 19.5 11.6784 19.5 9.75C19.4973 7.16498 18.4692 4.68661 16.6413 2.85872C14.8134 1.03084 12.335 0.00272983 9.75 0ZM9.75 15.75C9.5275 15.75 9.30999 15.684 9.12499 15.5604C8.93998 15.4368 8.79579 15.2611 8.71064 15.0555C8.62549 14.85 8.60321 14.6238 8.64662 14.4055C8.69003 14.1873 8.79718 13.9868 8.95451 13.8295C9.11184 13.6722 9.3123 13.565 9.53053 13.5216C9.74876 13.4782 9.97496 13.5005 10.1805 13.5856C10.3861 13.6708 10.5618 13.815 10.6854 14C10.809 14.185 10.875 14.4025 10.875 14.625C10.875 14.9234 10.7565 15.2095 10.5455 15.4205C10.3345 15.6315 10.0484 15.75 9.75 15.75ZM10.5 11.1825V11.25C10.5 11.4489 10.421 11.6397 10.2803 11.7803C10.1397 11.921 9.94892 12 9.75 12C9.55109 12 9.36033 11.921 9.21967 11.7803C9.07902 11.6397 9 11.4489 9 11.25V10.5C9 10.3011 9.07902 10.1103 9.21967 9.96967C9.36033 9.82902 9.55109 9.75 9.75 9.75C10.9903 9.75 12 8.90625 12 7.875C12 6.84375 10.9903 6 9.75 6C8.50969 6 7.5 6.84375 7.5 7.875V8.25C7.5 8.44891 7.42099 8.63968 7.28033 8.78033C7.13968 8.92098 6.94892 9 6.75 9C6.55109 9 6.36033 8.92098 6.21967 8.78033C6.07902 8.63968 6 8.44891 6 8.25V7.875C6 6.01406 7.68188 4.5 9.75 4.5C11.8181 4.5 13.5 6.01406 13.5 7.875C13.5 9.50437 12.21 10.8684 10.5 11.1825Z"
        fill="white"
      />
    </svg>
  )
}

export default QuestionMark
